"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurCorePromise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="224092" id="infrastruttura-e-sovranità-digitale" className="bg-background text-foreground py-16 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-10 pointer-events-none bg-[linear-gradient(to_right,#00E5FF_1px,transparent_1px),linear-gradient(to_bottom,#00E5FF_1px,transparent_1px)] bg-[size:40px_40px]"></div>
      
      <div className="mx-auto max-w-7xl px-4 md:px-6 text-center relative z-10">
        <h2 ref={ref} className={`font-default text-3xl md:text-[32px] font-bold leading-snug tracking-tight text-white transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          Garantiamo la piena conformità FZ-152 attraverso infrastrutture native e protocolli di sicurezza FSB per la sovranità dei dati in Russia.
        </h2>
      </div>

      {}
    </section>;
}